import { Button, DateField, Icons, List, message, ShowButton, Space, Table, Tag, Typography, useTable } from '@pankod/refine-antd'
import { useGetIdentity, useNavigation, useUpdate } from '@pankod/refine-core'
import PopupModal from 'components/PopupModal'
import React, { useState, useEffect } from 'react'
import Permissions from 'permissions'
import { useUserContext } from 'context/user'

const { ClockCircleOutlined, SyncOutlined } = Icons

type Permission = {
  granted?: boolean
}

export const ViewTaskList: React.FC = () => {
  const { userRole } = useUserContext()
  const { data: support } = useGetIdentity()
  const support_id = support?.id
  const [open, setOpen] = useState<boolean>(false)
  const [readPermission, setReadPermission] = useState<Permission>({})
  const { show, push } = useNavigation()
  const { mutateAsync } = useUpdate()
  const { tableProps } = useTable({
    resource: 'support_tasks',
    metaData: {
      fields: [
        'id',
        'uid',
        'active',
        'name',
        'start_date',
        'end_date',
        'assignee_id',
        'status',
        {
          assignee_user_details: ['id', 'displayName'],
        },
        'module_id',
        {
          module: ['id', 'label', 'value'],
        },
        'created_by',
        {
          created_by_user_details: ['id', 'displayName'],
        },
      ],
    },
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter: [
      {
        field: 'assignee_id',
        operator: 'eq',
        value: support_id,
      },
      {
        field: 'active',
        operator: 'eq',
        value: true,
      },
    ],
  })
  const columns: any = [
    {
      title: 'Task Id',
      dataIndex: 'uid',
    },
    {
      title: 'Name',
      // dataIndex: 'name',
      render: (record: any) => {
        console.log(record)
        return (
          <ShowButton size="small" type="link" icon={null} recordItemId={record?.id} onClick={() => show('tasks', record?.id)}>
            {record?.name}
          </ShowButton>
        )
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (value: any) => (
        <Tag color={value === 'Assigned' ? 'cyan' : value === 'Completed' ? 'green' : value === 'In Progress' ? 'blue' : undefined}>{value}</Tag>
      ),
    },
    {
      title: 'Assignee',
      dataIndex: 'assignee_user_details',
      render: (record: any) => <Typography.Text>{record?.displayName}</Typography.Text>,
    },
    {
      title: 'Start Date',
      dataIndex: 'start_date',
      render: (value: any) => <DateField format="DD-MMM-YY" value={value} />,
    },
    {
      title: 'Due Date',
      dataIndex: 'end_date',
      render: (value: any) => <DateField format="DD-MMM-YY" value={value} />,
    },
    {
      title: 'Created By',
      dataIndex: 'created_by_user_details',
      render: (record: any) => <Typography.Text>{record?.displayName}</Typography.Text>,
    },
    // {
    //   title: 'Actions',
    //   render: (record: any) => {
    //     return (
    //       <Space>
    //         <Tag
    //           icon={record?.status === 'Assigned' ? <ClockCircleOutlined spin /> : record?.status === 'In Progress' ? <SyncOutlined spin /> : null}
    //           color={
    //             record?.status === 'Assigned'
    //               ? 'gold'
    //               : record?.status === 'In Progress'
    //               ? 'processing'
    //               : record?.status === 'Completed'
    //               ? 'success'
    //               : record?.status === 'Retired'
    //               ? 'geekblue'
    //               : undefined
    //           }
    //           onClick={record?.status === 'Assigned' ? () => setOpen(true) : undefined}
    //         >
    //           {record?.status === 'Assigned'
    //             ? 'Accept'
    //             : record?.status === 'In Progress'
    //             ? 'Processing'
    //             : record?.status === 'Expired'
    //             ? 'Expired'
    //             : 'Completed'}
    //         </Tag>
    //         <PopupModal
    //           visible={open}
    //           close={() => {
    //             setOpen(false)
    //           }}
    //           title="Do you want to accept this task ?"
    //           confirm={() => {
    //             mutateAsync(
    //               {
    //                 resource: 'support_tasks',
    //                 id: record?.id,
    //                 values: {
    //                   status: 'In Progress',
    //                 },
    //                 successNotification: false,
    //               },
    //               {
    //                 onSuccess: () => {
    //                   setOpen(false)
    //                   message.open({
    //                     type: 'success',
    //                     content: 'Task Accepted',
    //                   })
    //                 },
    //               }
    //             )
    //           }}
    //         />
    //       </Space>
    //     )
    //   },
    // },
  ]
  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) push('/')
    // console.log(readPermission, 'readpermission')
  }, [readPermission])
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('tasks'))
      // setCreatePermission(Permissions.can(userRole).createAny('support_tasks'))
      // setEditPermission(Permissions.can(userRole).updateAny('support_tasks'))
      // setDeletePermission(Permissions.can(userRole).deleteAny('support_tasks'))
    }
  }, [userRole])
  return (
    <List
      pageHeaderProps={{
        title: 'Tasks',
      }}
    >
      <Table
        size="small"
        {...tableProps}
        columns={columns}
        dataSource={tableProps?.dataSource}
        rowKey="id"
        pagination={{
          ...tableProps?.pagination,
          showSizeChanger: true,
          pageSize: 10,
        }}
      />
    </List>
  )
}
